export default {
      id: "permCameraMic-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#permCameraMic-usage",
      toString: function () {
        return this.url;
      }
    }